export default "__VITE_ASSET__CBGW8_L___"